import { render, staticRenderFns } from "./DiscoverSection.vue?vue&type=template&id=3f261bcb"
import script from "./DiscoverSection.vue?vue&type=script&lang=js"
export * from "./DiscoverSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports